<div class="relative h-full w-full flex flex-col">
  <form [formGroup]="form" class="px-base flex flex-col md:flex-row gap-lg py-base">
    <lla-items-selector-filter
      class="block pr-[50px] md:pr-0 w-full md:w-[320px]"
      selectorClass="!-bottom-0"
      [inlineSearch]="true"
      [allItems]="allShopsDropDown"
      [selectedId]="form.get('shopId')?.value"
      selectMenuInputId="locationId"
      (selectedIdChanged)="form.get('shopId')?.setValue($event)"
    >
      <lla-input
        normalInputId="locationId"
        controlName="shopLabel"
        class="block -mb-sm"
        label="Select Location"
        type="text"
        size="small"
        icon="arrow-down"
        iconSize="12px"
        [readonly]="true"
      ></lla-input>
    </lla-items-selector-filter>

    @if (!onlyShopMarkers) {
      <div class="w-full md:w-[400px] flex">
        <div class="flex-1">
          <ngx-slider formControlName="radius" [options]="sliderOptions"></ngx-slider>
        </div>
        <span class="text-[15px]">Miles</span>
      </div>
    }
  </form>

  <div
    class="absolute top-xl right-base z-[100] bg-contrast text-txt shadow w-[40px] h-[40px] flex items-center justify-center cursor-pointer rounded-sm"
    (click)="closed.emit()"
  >
    <svg-icon key="close" class="!text-base"></svg-icon>
  </div>

  <div #map class="w-full flex-1"></div>

  @if (isLoading) {
    <div
      class="absolute z-[200] mg-admin-shops-map bg-gray-700/50 w-full h-full top-0 left-0 flex justify-center items-center"
    >
      <mat-progress-spinner [diameter]="50" mode="indeterminate"></mat-progress-spinner>
    </div>
  }
</div>
